import { pricingSimulatorUrls, tradePromoOptimizationUrls } from 'config/urls';
import { useCommonMutationHandler } from 'hooks/general/useCommonMutationHandler';
import react, { useState, createContext, FC, useContext } from 'react';
import { ErrorMessages, PricingSimulatorNotificationMessages } from 'utils/Enums';
import { downloadCsv, generateErrorMsg, sendNotification } from 'utils/helperMethods';
const { config } = require('../config/appConfig.ts');

const UserContext = createContext<{
    appConfig: any;
    exportSimulatorOptions: {
        exportSimulatorScenario: Function;
        exportScenarioLoading: boolean;
    };
    exportPromoLibraryOptions: {
        exportToolsData: Function;
        exportPromoLibraryLoading: boolean;
    };
}>({
    appConfig: {},
    exportSimulatorOptions: {
        exportScenarioLoading: false,
        exportSimulatorScenario: () => {},
    },
    exportPromoLibraryOptions: {
        exportPromoLibraryLoading: false,
        exportToolsData: () => {},
    },
});
interface props {
    children: React.ReactNode;
}

type Config = Record<string, any[]>;

const ConfigContext: FC<props> = ({ children }) => {
    const [state, setState] = useState<any>(loadConfigBasedOnTenant());
    const { mutate: exportScenario, loading: exportScenarioLoading } = useCommonMutationHandler({
        url: pricingSimulatorUrls.exportScenarioUrl,
        method: 'post',
    });

    const { mutate: exportPromoLibraryFn, loading: exportPromoLibraryLoading } = useCommonMutationHandler({
        url: tradePromoOptimizationUrls.getPromoLibraryTableDataExportUrl,
        method: 'post',
    });

    //adding function here so that it persists throughout the app
    function exportSimulatorScenario(payload: any, onSubmitClick: Function) {
        exportScenario(
            { ...payload },
            {
                onSuccess: (data) => {
                    const fileName = `${payload.project_name}_${payload.scenario_name}.csv`;
                    // Create a Blob from the CSV data
                    const blob = new Blob([data?.data], { type: 'text/csv' });

                    // Create a download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Set file name
                    document.body.appendChild(link);
                    link.click();

                    // Clean up and remove the link
                    link.parentNode?.removeChild(link);

                    //setting task id in local storage, so that on refresh polling would still work
                    //  localStorage.setItem('export_task_id', data?.data?.task_id || ''); //DO IT LATER
                    // onEditSuccess();
                    sendNotification(
                        'success',
                        `${payload.scenario_name} Export is ready! The download has started automatically`,
                        8,
                        500,
                    );
                    onSubmitClick(data?.data?.task_id || '', false);
                },
                onError: (error: any) => {
                    const errorMsg = generateErrorMsg(
                        String(error?.response?.data?.detail || ''),
                        PricingSimulatorNotificationMessages.GENERALIZED_ERROR_MSG,
                    );
                    //show error message
                    sendNotification('error', errorMsg);
                    onSubmitClick('', false);
                },
            },
        );
    }
    //adding function here so that it persists throughout the app

    function exportToolsData(variables: any, fileName: string) {
        exportPromoLibraryFn(variables, {
            onSuccess: (data) => {
                downloadCsv([data?.data], fileName);
                sendNotification('success', `Export is ready! The download has started automatically`, 5, 500);
            },
            onError: (error: any) => {
                const errorMsg = generateErrorMsg(
                    String(error?.response?.data?.detail || ''),
                    ErrorMessages.GENERALIZED_ERROR_MSG,
                );
                //show error message
                sendNotification('error', errorMsg);
            },
        });
    }

    function loadConfigBasedOnTenant() {
        const tenantId = process.env.REACT_APP_TENANT_ID || 'kind';
        return config[tenantId];
    }
    const exportSimulatorOptions = {
        exportScenarioLoading,
        exportSimulatorScenario,
    };

    const exportPromoLibraryOptions = {
        exportToolsData,
        exportPromoLibraryLoading,
    };
    return (
        <UserContext.Provider value={{ appConfig: state, exportSimulatorOptions, exportPromoLibraryOptions }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, ConfigContext };
